module.exports = __webpack_public_path__ + "assets/html5.46f3ce36.svg";